import { isNullable } from '@app/utils/isNullable'

export const navigateToExternalResource = (to: string, target = '_self'): void => {
  if (isNullable(window)) return

  window.open(to, target)
}
